import { useState, useEffect } from 'react'
import data from "../data.json";
import { useLocalStorage } from 'usehooks-ts'
import { ProjectData, ProjectItem } from '../Types';
import { Md5 } from 'ts-md5';

export default function useLoggedIn() {
    const [isLoggedIn, setIsLoggedIn] = useState(true);
    const [message, setMessage] = useState('');
    const [password, setPassword] = useLocalStorage('key', '');
    const [item, setItem] = useState<null | ProjectItem>(null);


    useEffect(() => {
        console.log('Password has changed: ', password);
        console.log(JSON.stringify(data));
        if (!password) {
            return;
        }


        let d: ProjectData = data;

        let foundItem: undefined | ProjectItem = d.find(item => {
            return password === item.pw;
        })

        if (foundItem) {
            setItem(foundItem);
            setMessage('');
        } else {
            setMessage("Lösenordet är felaktigt. Kontrollera lösenordet och försök igen.");
            setPassword('');
            setItem(null);
        }

    }, [password]);


    function setLoggedIn(value: boolean) {
        setIsLoggedIn(value);
    }

    function tryLogin(password: string) {



        const passwordMd5 = Md5.hashStr(password.toLowerCase());
        console.log("Hashed password:", passwordMd5, password.toLowerCase());

        setPassword(passwordMd5);

        // let d: ProjectData = data;

        // let foundItem: undefined | ProjectItem = d.find(item => {
        //     return passwordMd5 === item.pw;
        // })

        // if (foundItem) {
        //     setPassword(foundItem.pw);
        //     console.log("Logged in to", foundItem);
        //     // setItem(foundItem);
        // } else {
        //     console.log("Lösenordet är felaktigt. Kontrollera lösenordet och försök igen.");
        //     setPassword('');
        //     // setItem(null);
        // }

    }

    function logout() {
        setPassword('');
        setMessage('');
        setItem(null);
    }

    return { isLoggedIn, setLoggedIn, message, setMessage, password, tryLogin, item, logout };
}



